import React from 'react';
import { AuthState } from '../AuthState';
import { checkboxContainer, link } from '../styles';
import ReactCodeInput from 'react-code-input';
import { PinToggleProps } from '../types';

import 'react-phone-number-input/style.css';
import 'sweetalert2/dist/sweetalert2.css';
import { useAuthStep } from '../context/AuthStepContext';

const PinToggle = React.forwardRef<HTMLDivElement, PinToggleProps>(
  ({ label, type, autocomplete, submit }, ref) => {
    const { setIsSignInFlow } = useAuthStep();
    const codeUpdated = (e: string): void => {
      if (e.length === 4) {
        AuthState.pin = e;
        submit(AuthState.pin);
      }
    };

    const gotoEmailCode = (): void => {
      submit();
      setIsSignInFlow(false);
    };

    return (
      <div style={checkboxContainer}>
        <h3 style={{ marginBottom: '25px' }}>{label}</h3>
        <div>
          <ReactCodeInput
            name="pin-input"
            inputMode="numeric"
            value={AuthState.pin}
            fields={4}
            onChange={codeUpdated}
            type={'password'}
          />
        </div>
        <a role="button" style={link} onClick={gotoEmailCode}>
          <h6>I forgot my PIN or want to register</h6>
        </a>
      </div>
    );
  },
);

export { PinToggle };
